export function parseJwt(token) {
    var base64Url = token.split('.')[1];
    if (!base64Url) throw 'Invalid token';

    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
    );

    return JSON.parse(jsonPayload);
}

export function getToken() {
    const isGuestAccess = sessionStorage.getItem('guest_access');
    if (isGuestAccess) return sessionStorage.getItem('token');

    return localStorage.getItem('token');
}

export const validateToken = token => {
    try {
        const { exp } = parseJwt(token);
        const expiry = exp * 1000;

        return { token, expiry };
    } catch (error) {
        if (error === 'Invalid token') {
            console.log(error);
            return false;
        }
    }
};

export function getGuestAccessRefreshToken() {
    return sessionStorage.getItem('refresh_token');
}

export function getGuestAccessToken() {
    return sessionStorage.getItem('token');
}

export function getAuthToken() {
    return localStorage.getItem('token');
}
